import { render, staticRenderFns } from "./ListProductStockSlip.vue?vue&type=template&id=87721b8c&"
import script from "./ListProductStockSlip.vue?vue&type=script&lang=js&"
export * from "./ListProductStockSlip.vue?vue&type=script&lang=js&"
import style0 from "./ListProductStockSlip.vue?vue&type=style&index=0&id=87721b8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports